import type { TeamMatchDetailDto } from '@/api/backoffice-schemas';
import { cn } from '@/utils/cn';

interface ScoreProps {
  isWinner?: boolean;
  teamMatch: TeamMatchDetailDto;
  status: string;
  draw?: boolean;
}

export const Score = ({
  isWinner = false,
  teamMatch,
  status,
  draw,
}: ScoreProps) => {
  const getBackgroundColor = () => {
    if (status !== 'finished') {
      return 'bg-white-o20';
    }
    return isWinner ? 'bg-green-o20' : 'bg-red-o20';
  };

  return (
    <div
      className={cn('flex justify-center rounded px-3', getBackgroundColor())}
    >
      {status === 'finished' ? (draw ? '-' : (teamMatch.score ?? 0)) : '-'}
    </div>
  );
};
